'use client';

import { useState, useEffect } from 'react';
import { detectUserCountry, getCountryName } from '@/lib/geolocation';
import Icon from '@/components/ui/AppIcon';





interface CountrySelectorProps {
  currentCountry: string;
  onCountryChange: (country: string) => void;
  selectedLanguage: string;
  onLanguageChange: (language: string) => void;
  detectedCountry?: string | null;
}

const countries = [
  { code: 'IN', name: 'India', flag: '🇮🇳', languages: [{ code: 'en', name: 'English' }, { code: 'hi', name: 'हिन्दी' }, { code: 'ta', name: 'தமிழ்' }, { code: 'te', name: 'తెలుగు' }] },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬', languages: [{ code: 'en', name: 'English' }, { code: 'zh', name: '中文' }, { code: 'ms', name: 'Bahasa Melayu' }, { code: 'ta', name: 'தமிழ்' }] },
  { code: 'MY', name: 'Malaysia', flag: '🇲🇾', languages: [{ code: 'ms', name: 'Bahasa Melayu' }, { code: 'en', name: 'English' }, { code: 'zh', name: '中文' }] },
  { code: 'CN', name: 'China', flag: '🇨🇳', languages: [{ code: 'zh', name: '中文' }, { code: 'en', name: 'English' }] },
  { code: 'US', name: 'United States', flag: '🇺🇸', languages: [{ code: 'en', name: 'English' }, { code: 'es', name: 'Español' }] },
  { code: 'ID', name: 'Indonesia', flag: '🇮🇩', languages: [{ code: 'id', name: 'Bahasa Indonesia' }, { code: 'en', name: 'English' }] },
  { code: 'BR', name: 'Brazil', flag: '🇧🇷', languages: [{ code: 'pt', name: 'Português' }, { code: 'en', name: 'English' }] },
  { code: 'PK', name: 'Pakistan', flag: '🇵🇰', languages: [{ code: 'ur', name: 'اردو' }, { code: 'en', name: 'English' }] },
  { code: 'NG', name: 'Nigeria', flag: '🇳🇬', languages: [{ code: 'en', name: 'English' }, { code: 'yo', name: 'Yorùbá' }, { code: 'ha', name: 'Hausa' }] },
  { code: 'BD', name: 'Bangladesh', flag: '🇧🇩', languages: [{ code: 'bn', name: 'বাংলা' }, { code: 'en', name: 'English' }] },
  { code: 'RU', name: 'Russia', flag: '🇷🇺', languages: [{ code: 'ru', name: 'Русский' }, { code: 'en', name: 'English' }] },
  { code: 'MX', name: 'Mexico', flag: '🇲🇽', languages: [{ code: 'es', name: 'Español' }, { code: 'en', name: 'English' }] },
  { code: 'JP', name: 'Japan', flag: '🇯🇵', languages: [{ code: 'ja', name: '日本語' }, { code: 'en', name: 'English' }] },
  { code: 'PH', name: 'Philippines', flag: '🇵🇭', languages: [{ code: 'tl', name: 'Tagalog' }, { code: 'en', name: 'English' }] },
  { code: 'VN', name: 'Vietnam', flag: '🇻🇳', languages: [{ code: 'vi', name: 'Tiếng Việt' }, { code: 'en', name: 'English' }] },
  { code: 'TR', name: 'Turkey', flag: '🇹🇷', languages: [{ code: 'tr', name: 'Türkçe' }, { code: 'en', name: 'English' }] },
  { code: 'DE', name: 'Germany', flag: '🇩🇪', languages: [{ code: 'de', name: 'Deutsch' }, { code: 'en', name: 'English' }] },
  { code: 'GB', name: 'United Kingdom', flag: '🇬🇧', languages: [{ code: 'en', name: 'English' }] },
  { code: 'FR', name: 'France', flag: '🇫🇷', languages: [{ code: 'fr', name: 'Français' }, { code: 'en', name: 'English' }] },
  { code: 'TH', name: 'Thailand', flag: '🇹🇭', languages: [{ code: 'th', name: 'ไทย' }, { code: 'en', name: 'English' }] },
  { code: 'IT', name: 'Italy', flag: '🇮🇹', languages: [{ code: 'it', name: 'Italiano' }, { code: 'en', name: 'English' }] },
  { code: 'KR', name: 'South Korea', flag: '🇰🇷', languages: [{ code: 'ko', name: '한국어' }, { code: 'en', name: 'English' }] },
  { code: 'EG', name: 'Egypt', flag: '🇪🇬', languages: [{ code: 'ar', name: 'العربية' }, { code: 'en', name: 'English' }] },
  { code: 'IR', name: 'Iran', flag: '🇮🇷', languages: [{ code: 'fa', name: 'فارسی' }, { code: 'en', name: 'English' }] },
  { code: 'ES', name: 'Spain', flag: '🇪🇸', languages: [{ code: 'es', name: 'Español' }, { code: 'en', name: 'English' }] },
  { code: 'AR', name: 'Argentina', flag: '🇦🇷', languages: [{ code: 'es', name: 'Español' }, { code: 'en', name: 'English' }] },
  { code: 'CO', name: 'Colombia', flag: '🇨🇴', languages: [{ code: 'es', name: 'Español' }, { code: 'en', name: 'English' }] },
  { code: 'CA', name: 'Canada', flag: '🇨🇦', languages: [{ code: 'en', name: 'English' }, { code: 'fr', name: 'Français' }] },
  { code: 'PL', name: 'Poland', flag: '🇵🇱', languages: [{ code: 'pl', name: 'Polski' }, { code: 'en', name: 'English' }] },
  { code: 'SA', name: 'Saudi Arabia', flag: '🇸🇦', languages: [{ code: 'ar', name: 'العربية' }, { code: 'en', name: 'English' }] },
  { code: 'UA', name: 'Ukraine', flag: '🇺🇦', languages: [{ code: 'uk', name: 'Українська' }, { code: 'en', name: 'English' }] },
  { code: 'AU', name: 'Australia', flag: '🇦🇺', languages: [{ code: 'en', name: 'English' }] },
];

export default function CountrySelector({ currentCountry, onCountryChange, selectedLanguage, onLanguageChange, detectedCountry }: CountrySelectorProps) {
  const [isHydrated, setIsHydrated] = useState(false);
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const [viewerCountryName, setViewerCountryName] = useState<string>('');
  const [internalDetectedCountry, setInternalDetectedCountry] = useState<string | null>(null);

  useEffect(() => {
    const detectCountry = async () => {
      const country = await detectUserCountry();
      setInternalDetectedCountry(country);
      setViewerCountryName(getCountryName(country));
    };
    detectCountry();
    setIsHydrated(true);
  }, []);

  const getCurrentCountryDisplay = () => {
    if (currentCountry === 'WORLD') return { flag: '🌍', name: 'World', languages: [{ code: 'en', name: 'English' }] };
    const country = countries.find(c => c.code === currentCountry);
    return country || { flag: '🌍', name: 'World', languages: [{ code: 'en', name: 'English' }] };
  };

  if (!isHydrated) {
    return (
      <div className="flex items-center justify-between w-full">
        <div className="flex flex-col">
          <div className="w-32 h-8 bg-muted rounded animate-pulse"></div>
          <div className="w-48 h-4 bg-muted rounded animate-pulse mt-1"></div>
        </div>
        <div className="w-32 h-8 bg-muted rounded animate-pulse"></div>
      </div>
    );
  }

  const currentDisplay = getCurrentCountryDisplay();
  const currentLanguageName = currentDisplay.languages.find(l => l.code === selectedLanguage)?.name || 'English';

  return (
    <div className="flex items-center gap-4">
      {/* Country Display with Detection Info */}
      <div className="flex items-center gap-2">
        <Icon name="MapPinIcon" size={20} className="text-primary" />
        <span className="text-xl">{currentDisplay.flag}</span>
        <div className="flex flex-col">
          <span className="font-medium text-foreground">{currentDisplay.name}</span>
          {(detectedCountry || internalDetectedCountry) && (detectedCountry || internalDetectedCountry) === currentCountry && (
            <span className="text-xs text-muted-foreground">Detected location</span>
          )}
        </div>
      </div>
    
      {/* Language Selector */}
      <div className="relative">
        <button
          onClick={() => setShowLanguageMenu(!showLanguageMenu)}
          className="flex items-center gap-2 px-3 py-1.5 rounded-lg border border-border bg-card hover:bg-muted transition-colors"
        >
          <Icon name="LanguageIcon" size={18} className="text-primary" />
          <span className="text-sm font-medium text-foreground">{currentLanguageName}</span>
          <Icon name="ChevronDownIcon" size={16} className="text-muted-foreground" />
        </button>

        {showLanguageMenu && (
          <div className="absolute top-full left-0 mt-2 bg-card border border-border rounded-lg shadow-lg p-2 z-50 min-w-[180px]">
            {currentDisplay.languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => {
                  onLanguageChange(lang.code);
                  setShowLanguageMenu(false);
                }}
                className={`flex items-center gap-2 w-full px-3 py-2 text-sm rounded transition-colors ${
                  selectedLanguage === lang.code
                    ? 'bg-primary text-primary-foreground'
                    : 'text-foreground hover:bg-muted'
                }`}
              >
                <span>{lang.name}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export { countries };